<template>
    <div>
        <b-row align-h="center">
            <b-calendar v-model="form.date" :min="minDate" :date-disabled-fn="disabledDates" @selected="verifySelectedDate" selected-variant="success"
                nav-button-variant="success" today-variant="info" locale="pt-BR" hide-header no-key-nav label-help=""
                class="border-0 border-dark">
            </b-calendar>
        </b-row>

        <b-row align-h="center">
            <div v-if="availableHorarys && availableHorarys.length > 0" class="pt-2 pb-1 justify-content-start d-flex">
                <div v-for="(horary, idx) in availableHorarys" :key="idx" class="pr-3">
                    <b-button @click="selectHorary(horary, idx)" :disabled="disabledHorary(horary)" :pressed="form.time == horary.time" variant="basic" class="rounded pt-2 pb-2">
                        {{ horary.time }}

                        <div v-if="!disabledHorary(horary) && horary.available > 0">
                          <hr class="mt-0 mb-0">
                          {{ horary.available > 0 ? horary.available + " vagas" : '' }}
                        </div>

                        <div v-else>
                          <span style="color: red;">
                            indisponível
                          </span>
                        </div>
                    </b-button>
                </div>
            </div>

            <div v-else class="pt-2">
                <h3>Sem novos horários disponíveis para a data {{ formattedDate(form.date, "DD/MM/YYYY") }} </h3>
            </div>
        </b-row>

        <b-row>
            <template span="modal-footer">
                <div class="w-100 pt-6 pr-2 text-right">
                    <b-button @click="closeModal()" variant="secondary">Cancelar</b-button>
                    <b-button @click="confirmDateChange()" :disabled="disabledSaveButton" variant="primary">Salvar</b-button>
                </div>
            </template>
        </b-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from "moment"
import swal from "sweetalert2"

export default {
    name: 'CalendarChangeBookingDate',

    components: {

    },

    props: {
        bookingDetails: {
            type: Object,
            default: () => ({}),
        },

        showDateChangeModal: {
            type: Boolean,
            default: () => (true),
        },

        PLACE_UUID: {
            type: String,
            default: () => (""),
        },

        PRODUCT_UUID: {
            type: String,
            default: () => (""),
        },
    },

    watch: {
        poisList(newValue, oldValue){
            if(newValue){
                this.atrativo = newValue[0]
                this.getCapacity()
            }
        },

        ['form.date'](newValue, oldValue){
            if(newValue && newValue.length > 0){
                if(moment(newValue).isSameOrBefore(moment(this.minDate), 'day') || moment(newValue).isBefore(moment(), 'day') || !this.dates.includes(newValue)){
                    this.$notify({ message: 'Escolha outra data', duration: 3000, type: 'warning'})
                }

                this.form.time = ""
            }
        }
    },

    computed: {
        ...mapGetters('product', {
            poisList: 'getPois',
        }),

        dates(){ return this.capacity.length > 0 ? this.capacity.map(function(value, index){ return value[0] }) : [] },

        disabledSaveButton(){
            if(this.form.date == "" || this.form.time.length == 0 ||
                (this.form.date == moment(this.bookingDetails.payload.booking_date).format("YYYY-MM-DD") && this.form.time == moment(this.bookingDetails.payload.booking_date).format("HH:mm")  ) ){
                return true
            }

            else { return false }
        },

        availableHorarys(){
            var horary = [{ date: this.form.date, time: this.form.time, blocked: true, }]
            var vm = this

            if(this.form.date && this.capacity.length > 0){
                horary = this.capacity.map(function(value, index){
                    if(value[0] == vm.form.date){ return value[1] }
                }).filter(i => i != undefined)[0]
            }

            return horary
        },

    },

    data() {
        return {
            atrativo: {}, capacity: {}, minDate: new Date(),
            form: { date: '', time: '', },
        }
    },

    methods: {
        ...mapActions('product', [
            'fetchPOIs',
        ]),

        ...mapActions('agent', [
            "updateExpressBookingDate",
        ]),

        closeModal(){ this.$emit("emitCloseDateChangeModal") },

        //TODO use utils.general.formatDate
        formattedDate(date, format){ return moment(date).format(format) },

        selectHorary(horary, index) {
            if (this.form.time.length > 0 && this.form.time == horary.time) { this.form.time = "" }
            else{ this.form.time = horary.time }
        },

        async confirmDateChange(){
            swal.fire({
                text: `Confirmar alteração de data para ${moment(this.form.date + " " + this.form.time).format("DD/MM/YYYY HH[h]")}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Alterar',
                confirmButtonColor: '#12576e',
                cancelButtonText: 'Cancelar',
                cancelButtonColor: 'secondary',
                reverseButtons: true,
                type: 'default'
            })
            .then((result => {
                if (result.isConfirmed) {
                    this.$emit("setIsLoading", true)
                    this.updateExpressBookingDate({
                        date: this.form.date + " " + this.form.time,
                        hash: this.bookingDetails.hash
                      })
                      .then(() => {
                        this.$emit("bookingDateUpdated")
                      })
                      .catch((error) => {
                        // nodeApi3 rejeita com o response; a mensagem da API vem em data
                        const apiMessage = error && error.data && error.data.message
                        console.error('alterar a data da reserva failed', { hash: this.bookingDetails && this.bookingDetails.hash, error })
                        this.$emit("setIsLoading", false)
                        swal.fire({
                          text: apiMessage
                            ? `Não foi possível alterar a data da reserva: ${apiMessage}`
                            : "Não foi possível alterar a data da reserva.",
                          icon: 'error',
                          confirmButtonText: 'Fechar',
                          confirmButtonColor: '#D93051',
                        })
                      })
                }
            }))
        },

        disabledDates(dateTime) {
            let isBlocked = false
            if(moment(dateTime).isBefore(moment(this.minDate)) || !this.dates.includes(dateTime)){
                isBlocked = true
            }
            return isBlocked
        },

        verifySelectedDate(ymd, date){
            var vm = this

            this.availableHorarys.map(function(value, index){
                if(!vm.disabledHorary(value) && value.available > 0 && index == 0){
                    vm.form.time = value.time
                }
            })
        },

        getCapacity(){
            if(this.atrativo && this.atrativo.capacity){
                let capacity_datetime = {}

                let avaiableDates = Object.entries(this.atrativo.capacity).filter(cap => moment(cap[0]).isValid())
                avaiableDates = avaiableDates.map(function(value, index){
                    let dates = Object.entries(value[1])

                    dates = dates.map(function(val, idx){
                        let date = val[0].split(" ")[0]
                        let time = val[0].split(" ")[1]
                        if(date != undefined && time != undefined){
                            capacity_datetime = {
                                date: date,
                                time: time,
                                available: Number(val[1].available),
                                booked: Number(val[1].booked)
                            }
                        }
                        return capacity_datetime
                    })

                    return dates
                }).flat().filter(i => Object.keys(i).length !== 0)

                // REMOVING DUPLICATES
                avaiableDates = avaiableDates.filter((date_1, i, arr) => arr.findIndex(date_2 => JSON.stringify(date_2) === JSON.stringify(date_1) ) === i)

                this.capacity = this.groupBy(avaiableDates, item => item.date)
            }
            else { this.capacity = [] }
        },

        disabledHorary(horary){
            var disabled = false
            disabled = ( horary.blocked || horary.available <= 0 || moment(horary.date).isBefore(moment(), 'day') ||
                (horary.date == moment(this.bookingDetails.payload.booking_date).format("YYYY-MM-DD") &&
                horary.time == moment(this.bookingDetails.payload.booking_date).format("HH:mm"))
            )

            return disabled
        },

        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);

                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },

        handleBackDateChange(){
            if(this.showDateChangeModal){
                this.closeModal()
                return
            }
            else {
                this.$router.back()
                return
            }
        },

    },

    async mounted() {
        await this.fetchPOIs({ PLACE_UUID: this.PLACE_UUID, PRODUCT_UUID: this.PRODUCT_UUID })

        this.minDate = new Date()
        this.minDate.setDate(this.minDate.getDate() + this.atrativo.days_in_advance);

        this.form.date = moment(this.bookingDetails.payload.booking_date).format("YYYY-MM-DD")
        this.form.time = moment(this.bookingDetails.payload.booking_date).format("HH:mm")
    },

    created() { window.addEventListener("popstate", this.handleBackDateChange); },
    beforeDestroy() { window.removeEventListener("popstate", this.handleBackDateChange); },

}
</script>
